import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6094f7e3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "qrcode"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "use"
}, [/*#__PURE__*/_createTextVNode("Please use "), /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#2BA246"
  }
}, "LINE"), /*#__PURE__*/_createTextVNode(" to scan the code for players")], -1));
import { ref } from 'vue';
import vueQr from 'vue-qr/src/packages/vue-qr.vue';
import useActionsStore from '@/stores/modules/actions';

//const showQRCode = ref(true)
//从pinia 中获取数据

export default {
  __name: 'qr-code',
  setup(__props) {
    const actionsStore = useActionsStore();
    return (_ctx, _cache) => {
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
        class: "qr-popup",
        show: _unref(actionsStore).qrCode.showQRCode,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => _unref(actionsStore).qrCode.showQRCode = $event),
        closeable: "",
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(vueQr, {
          text: _unref(actionsStore).qrCode.qrContent,
          size: 260
        }, null, 8, ["text"]), _hoisted_3])]),
        _: 1
      }, 8, ["show"])]);
    };
  }
};